import { useRef, useState } from "react";
import { motion } from "framer-motion";

const FoilCard = () => {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ rx: 0, ry: 0, gx: 50, gy: 50, active: false });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    setTilt({ rx: (0.5 - py) * 16, ry: (px - 0.5) * 20, gx: px * 100, gy: py * 100, active: true });
  };

  const onLeave = () => setTilt({ rx: 0, ry: 0, gx: 50, gy: 50, active: false });

  return (
    <motion.div
      animate={{ y: [0, -12, 0] }}
      transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      className="relative"
      data-testid="hero-foil-card"
    >
      <div
        className="absolute -inset-8 rounded-full blur-3xl"
        style={{ background: "radial-gradient(circle, rgba(122,217,194,0.22), rgba(216,167,65,0.12) 55%, transparent 75%)" }}
        aria-hidden="true"
      />
      <div
        ref={ref}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        className="relative w-[280px] cursor-pointer select-none sm:w-[320px]"
        style={{
          transform: `perspective(1000px) rotateX(${tilt.rx}deg) rotateY(${tilt.ry}deg)`,
          transition: tilt.active ? "transform 0.08s linear" : "transform 0.6s cubic-bezier(0.22,1,0.36,1)",
          transformStyle: "preserve-3d",
        }}
      >
        <div className="card-frame overflow-hidden !rounded-2xl p-3 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
          <div className="relative overflow-hidden rounded-xl border border-gold/40">
            <img
              src="https://images.unsplash.com/photo-1672759043182-dde5467f8f76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxwb2tlbW9uJTIwbWFnaWMlMjB0cmFkaW5nJTIwY2FyZHMlMjBjb2xsZWN0aW9uJTIwZm9pbCUyMGdvbGQlMjB2YXVsdHxlbnwwfHx8fDE3ODg3MjgyNjR8MA&ixlib=rb-4.1.0&q=85"
              alt="Gold foil Pokémon trading card"
              className="aspect-[3/4] w-full object-cover"
              loading="eager"
            />
            <div
              className="pointer-events-none absolute inset-0"
              style={{
                background: `radial-gradient(circle at ${tilt.gx}% ${tilt.gy}%, rgba(247,241,230,0.35), rgba(122,217,194,0.12) 35%, transparent 65%)`,
                opacity: tilt.active ? 1 : 0.4,
                transition: "opacity 0.3s",
              }}
              aria-hidden="true"
            />
          </div>
          <div className="flex items-center justify-between px-2 py-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-mint">Vault Verified</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">FOIL · 001</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FoilCard;
